<template>
  <b v-if="item">{{ tday }} дней [ {{ thour }} : {{ tmin }} : {{ tsec }} ]</b>
</template>

<script>
export default {
  data: () => ({
    tday: "00",
    thour: "00",
    tmin: "00",
    tsec: "00",
    today: "",
  }),
  name: "Timer",
  props: ["item", "before"],
  methods: {
    dateToUTC(date) {
      return (
        date.getUTCFullYear() +
        "-" +
        (date.getUTCMonth()) +
        "-" +
        date.getUTCDate() +
        " " +
        date.getUTCHours() +
        ":" +
        date.getUTCMinutes() +
        ":" +
        date.getUTCSeconds()
      );

      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      );
    },
    addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    timeInterval() {
      if (this.before) {
        var dateBefore = this.dateToUTC(
          this.addMinutes(new Date(this.before), 2222)
        );

        alert(dateBefore)
;
        let a = dateBefore.split(" ");

        let d = a[0].split("-");

        let t = a[1].split(":");

        let timeend = dateBefore;

        this.today = Math.round(new Date().getTime());

        this.today = Math.floor((timeend - this.today) / 1000);

        this.tsec = this.today % 60;

        this.today = Math.floor(this.today / 60);

        if (this.tsec < 10 && this.tsec > -1) this.tsec = "0" + this.tsec;

        this.tmin = this.today % 60;

        this.today = Math.floor(this.today / 60);

        if (this.tmin < 10 && this.tmin > -1) this.tmin = "0" + this.tmin;

        this.thour = this.today % 24;

        this.tday = Math.ceil(this.today / 24);

        if (this.thour < 10 && this.thour > -1) this.thour = "0" + this.thour;

        if (this.thour < 0) {
          this.thour = "00";
        }
        if (this.tmin < 0) {
          this.tmin = "00";
        }
        if (this.tsec < 0) {
          this.tsec = "00";
        }

        this.today = Math.floor(this.today / 24);

        window.setTimeout(() => {
          this.timeInterval();
        }, 1000);
      }
    },
  },
  created() {
    this.timeInterval();
  },
};
</script>